import React, { useRef } from "react";
import { useNavigate } from "react-router-dom";

import adventurous from "../assets/HomePage/adventurous-2.png";
import calming from "../assets/HomePage/calming-2.png";
import energized from "../assets/HomePage/energized-2.png";
import feelGood from "../assets/HomePage/feel_good-1.png";
import healing from "../assets/HomePage/healing-2.png";
import relaxing from "../assets/HomePage/relaxing-2.png";
import refreshing from "../assets/HomePage/refreshing-2.png";
import wakeMeUp from "../assets/HomePage/wake_me_up-1.png";

export default function TeaMoodTime() {
  const navigate = useNavigate();
  const cardRefs = useRef([]);

  const moods = [
    { title: "Adventurous", img: adventurous },
    { title: "Calming", img: calming },
    { title: "Energizing", img: energized },
    { title: "Feel Good", img: feelGood },
    { title: "Healing", img: healing },
    { title: "Relaxing", img: relaxing },
    { title: "Refreshing", img: refreshing },
    { title: "Wake Me Up", img: wakeMeUp }
  ];

  const handleMouseMove = (e, index) => {
    const card = cardRefs.current[index];
    if (!card) return;

    const rect = card.getBoundingClientRect();
    const x = e.clientX - rect.left - rect.width / 2;
    const y = e.clientY - rect.top - rect.height / 2;

    card.style.transition = "transform 0s";
    card.style.transform = `
      perspective(600px)
      rotateX(${(-y / 20).toFixed(2)}deg)
      rotateY(${(x / 20).toFixed(2)}deg)
      scale(1.15)
    `;
  };

  const resetAnimation = (index) => {
    const card = cardRefs.current[index];
    if (!card) return;

    card.style.transition = "transform 0.4s ease";
    card.style.transform = "rotateX(0) rotateY(0) scale(1)";
  };

  const handleMoodClick = (moodTitle) => {
    const encoded = encodeURIComponent(moodTitle);
    navigate(`/mood/${encoded}`);

    window.scrollTo(0, 0); // FIX
  };


  return (
    <section className="w-full py-24 bg-white">
      <h2 className="text-center text-4xl md:text-5xl font-serif text-[#222] mb-16 tracking-wider">
        WHAT&apos;S YOUR MOOD?
      </h2>

      <div className="flex flex-wrap justify-center gap-10 px-4">
        {moods.map((item, index) => (
          <div
            key={item.title}
            className="cursor-pointer group flex flex-col items-center text-center"
            onClick={() => handleMoodClick(item.title)}
          >
            <div
              ref={(el) => (cardRefs.current[index] = el)}
              className="relative w-24 h-24 md:w-28 md:h-28 rounded-full border border-gray-200 flex items-center justify-center bg-white shadow-lg hover:shadow-2xl transition"
              onMouseMove={(e) => handleMouseMove(e, index)}
              onMouseLeave={() => resetAnimation(index)}
            >
              <img
                src={item.img}
                alt={item.title}
                className="w-12 h-12 md:w-16 md:h-16 object-contain"
              />
            </div>

            <p className="text-sm md:text-base text-gray-700 font-medium mt-4">
              {item.title}
            </p>
          </div>
        ))}
      </div>
    </section>
  );
}
